import { render, staticRenderFns } from "./InvoiceViewModal.vue?vue&type=template&id=2b663dd4&"
import script from "./InvoiceViewModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports